<template>
  <div class="wrapper">
    <parallax
        class="section page-header header-filter"
        parallax-active="true"
        :style="headerStyle"
    />
    <div class="main main-raised">
      <div class="section profile-content">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-50 md-small-size-100 mx-auto">
              <div class="profile">
                <div class="avatar">
                  <!--                  <img
                                      :src="img"
                                      alt="Circle Image"
                                      class="img-raised rounded-circle img-fluid"
                                    >-->
                </div>
                <div class="name">
                  <h3 class="title">
                    What is the Hyperlinks
                  </h3>
                  <!--                  <h6>Designer</h6>
                                    <md-button
                                      href="javascript:void(0)"
                                      class="md-just-icon md-simple md-dribbble"
                                    >
                                      <i class="fab fa-dribbble" />
                                    </md-button>
                                    <md-button
                                      href="javascript:void(0)"
                                      class="md-just-icon md-simple md-twitter"
                                    >
                                      <i class="fab fa-twitter" />
                                    </md-button>
                                    <md-button
                                      href="javascript:void(0)"
                                      class="md-just-icon md-simple md-pinterest"
                                    >
                                      <i class="fab fa-pinterest" />
                                    </md-button>-->
                </div>
                <!--                <div class="follow">
                                  <md-button class="md-success md-just-icon md-round">
                                    <md-icon>add</md-icon>
                                    <md-tooltip md-direction="top">
                                      Follow this user
                                    </md-tooltip>
                                  </md-button>
                                </div>-->
              </div>
            </div>
          </div>
          <div class="description text-left">
            <p>
              Hyperlinks are tailored for stable and long-term publishers, Smartlink+.
              Here we introduce the concept of stocks and funds to help those publishers without strong operational
              capabilities to maximize ROI.
            </p>

            <ul>
              <li>According to the publishers traffic type, carry out the offer pool orientation, such as vertical type,
                privacy, user group, Cost Model
              </li>
              <li>Dynamically optimize the proportion of Good converting offers in the offer pool according to the
                effect of the Publisher. Ensure that the Publisher revenue is maximized, and part of the traffic is to
                try new categories & new offers.
              </li>
              <li>Ensure the advertiser's brand safety and budget safety. Optimize KPI indicators, etc.
              </li>
            </ul>


            <h4 class="title title-margin">
              About the Stats
            </h4>

            <div class="md-layout">

              <div
                  class="md-layout-item md-size-100 md-small-size-100 ml-auto"
              >
                <template v-for="item in contentLeft">
                  <info-areas
                      :key="item.title"
                      text-left
                      info-horizontal
                      :icon-color="item.colorIcon"
                      :icon="item.icon"
                  >
                    <h4
                        slot="title"
                        class="info-title"
                    >
                      {{ item.title }}
                    </h4>
                    <div
                        slot="content"
                        class="description"
                    >
                      <p>{{ item.description }}</p>
                    </div>
                  </info-areas>
                </template>
              </div>
            </div>

            <p class="description">
              At present, we have 1000+ hyperlinks at work every day, which can assist the Publisher to obtain 20K+ U.S.
              dollars in revenue every day, and the revenue growth brought by hyperlinks to the Publisher exceeds 20%
            </p>
          </div>
          <!--          <div class="profile-tabs">
                      <tabs
                        :tab-active="1"
                        :tab-name="['Studio', 'Work', 'Favorite']"
                        :tab-icon="['camera', 'palette', 'favorite']"
                        plain
                        nav-pills-icons
                        color-button="success"
                      >
                        &lt;!&ndash; here you can add your content for tab-content &ndash;&gt;
                        <template slot="tab-pane-1">
                          <div class="md-layout work">
                           <div
                              class="md-layout-item md-size-60 md-small-size-100 mx-auto"
                            >
                              <h4 class="title">
                                Latest Collections
                              </h4>
                              <div class="md-layout collections">
                                <div class="md-layout-item md-size-50 md-small-size-100">
                                  <full-bg-card :card-image="cardFullBg.fullBg1">
                                    <template slot="cardContent">
                                      <badge type="warning">
                                        Spring 2016
                                      </badge>
                                      <a href="javascript:void(0)">
                                        <h2 class="card-title">Espace</h2>
                                      </a>
                                    </template>
                                  </full-bg-card>
                                </div>
                                <div class="md-layout-item md-size-50 md-small-size-100">
                                  <full-bg-card :card-image="cardFullBg.fullBg2">
                                    <template slot="cardContent">
                                      <badge type="info">
                                        Spring 2016
                                      </badge>
                                      <a href="javascript:void(0)">
                                        <h2 class="card-title">Portland Rose</h2>
                                      </a>
                                    </template>
                                  </full-bg-card>
                                </div>
                                <div class="md-layout-item md-size-50 md-small-size-100">
                                  <full-bg-card :card-image="cardFullBg.fullBg3">
                                    <template slot="cardContent">
                                      <badge type="danger">
                                        Summer 2016
                                      </badge>
                                      <a href="javascript:void(0)">
                                        <h2 class="card-title">Canberra</h2>
                                      </a>
                                    </template>
                                  </full-bg-card>
                                </div>
                                <div class="md-layout-item md-size-50 md-small-size-100">
                                  <full-bg-card :card-image="cardFullBg.fullBg4">
                                    <template slot="cardContent">
                                      <badge type="success">
                                        Winter 2015
                                      </badge>
                                      <a href="javascript:void(0)">
                                        <h2 class="card-title">Floralia</h2>
                                      </a>
                                    </template>
                                  </full-bg-card>
                                </div>
                              </div>
                            </div>
                            <div
                              class="md-layout-item md-size-20 md-small-size-100 mx-auto stats"
                            >

                            </div>
                          </div>
                        </template>
                        <template slot="tab-pane-2">
                          <div class="md-layout">
                            <div
                              class="md-layout-item md-size-40 md-small-size-100 mx-auto"
                            >
                              <profile-card
                                card-plain
                                type="horizontal"
                                :shadow-normal="false"
                                :no-colored-shadow="false"
                                :card-image="cardProfile3.cardProfile1"
                              >
                                <template slot="cardContent">
                                  <h4 class="card-title">
                                    Gigi Hadid
                                  </h4>
                                  <h6 class="card-category text-muted">
                                    Model
                                  </h6>
                                  <p class="card-description">
                                    Don't be scared of the truth because we need to
                                    restart the human foundation in truth...
                                  </p>
                                </template>
                              </profile-card>
                            </div>
                            <div
                              class="md-layout-item md-size-40 md-small-size-100 mx-auto"
                            >
                              <profile-card
                                card-plain
                                type="horizontal"
                                :shadow-normal="false"
                                :no-colored-shadow="false"
                                :card-image="cardProfile3.cardProfile2"
                              >
                                <template slot="cardContent">
                                  <h4 class="card-title">
                                    Marc Jacobs
                                  </h4>
                                  <h6 class="card-category text-muted">
                                    Designer
                                  </h6>
                                  <p class="card-description">
                                    Don't be scared of the truth because we need to
                                    restart the human foundation in truth...
                                  </p>
                                </template>
                              </profile-card>
                            </div>
                          </div>
                          <div class="md-layout">
                            <div
                              class="md-layout-item md-size-40 md-small-size-100 mx-auto"
                            >
                              <profile-card
                                card-plain
                                type="horizontal"
                                :shadow-normal="false"
                                :no-colored-shadow="false"
                                :card-image="cardProfile3.cardProfile3"
                              >
                                <template slot="cardContent">
                                  <h4 class="card-title">
                                    Kendall Jenner
                                  </h4>
                                  <h6 class="card-category text-muted">
                                    Model
                                  </h6>
                                  <p class="card-description">
                                    Don't be scared of the truth because we need to
                                    restart the human foundation in truth...
                                  </p>
                                </template>
                              </profile-card>
                            </div>
                            <div
                              class="md-layout-item md-size-40 md-small-size-100 mx-auto"
                            >
                              <profile-card
                                card-plain
                                type="horizontal"
                                :shadow-normal="false"
                                :no-colored-shadow="false"
                                :card-image="cardProfile3.cardProfile4"
                              >
                                <template slot="cardContent">
                                  <h4 class="card-title">
                                    George West
                                  </h4>
                                  <h6 class="card-category text-muted">
                                    Model/Dj
                                  </h6>
                                  <p class="card-description">
                                    Don't be scared of the truth because we need to
                                    restart the human foundation in truth...
                                  </p>
                                </template>
                              </profile-card>
                            </div>
                          </div>
                        </template>
                        <template slot="tab-pane-3">
                          <div class="md-layout">
                            <div
                              class="md-layout-item md-size-25 md-small-size-100 ml-auto"
                            >
                              <img
                                :src="tabPane3[0].image"
                                class="rounded"
                              >
                              <img
                                :src="tabPane3[1].image"
                                class="rounded"
                              >
                            </div>
                            <div
                              class="md-layout-item md-size-25 md-small-size-100 mr-auto"
                            >
                              <img
                                :src="tabPane3[2].image"
                                class="rounded"
                              >
                              <img
                                :src="tabPane3[3].image"
                                class="rounded"
                              >
                              <img
                                :src="tabPane3[4].image"
                                class="rounded"
                              >
                            </div>
                          </div>
                        </template>
                      </tabs>
                    </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Tabs, FullBgCard, ProfileCard, Badge} from "@/components";
import Mixins from "@/plugins/basicMixins";

export default {
  /*  components: {
      Tabs,
      FullBgCard,
      ProfileCard,
      Badge
    },*/
  mixins: [Mixins.HeaderImage],
  bodyClass: "profile-page",
  data() {
    return {
      contentLeft: [
        {
          colorIcon: "success",
          icon: "timeline",
          title: "Volumes",
          description:
              "1000+ Hyperlinks works very day"
        },

        {
          colorIcon: "danger",
          icon: "code",
          title: "ROI",
          description:
              "ROI increase 20%+ than before"
        },

        {
          colorIcon: "info",
          icon: "group",
          title: "Revenue",
          description:
              "Hyperlinks take 20K+ daily$"
        }
      ],
      image: require("@/assets/img/bg/bg9.jpg"),
      img: require("@/assets/img/faces/christian.jpg"),
      cardFullBg: {
        fullBg1: require("@/assets/img/examples/mariya-georgieva.jpg"),
        fullBg2: require("@/assets/img/examples/clem-onojeghuo.jpg"),
        fullBg3: require("@/assets/img/examples/olu-eletu.jpg"),
        fullBg4: require("@/assets/img/examples/floralia.jpg")
      },
      cardProfile3: {
        cardProfile1: require("@/assets/img/faces/avatar.jpg"),
        cardProfile2: require("@/assets/img/faces/marc.jpg"),
        cardProfile3: require("@/assets/img/faces/kendall.jpg"),
        cardProfile4: require("@/assets/img/faces/card-profile2-square.jpg")
      },
      tabPane1: [
        {image: require("@/assets/img/examples/studio-1.jpg")},
        {image: require("@/assets/img/examples/studio-2.jpg")},
        {image: require("@/assets/img/examples/studio-4.jpg")},
        {image: require("@/assets/img/examples/studio-5.jpg")}
      ],
      tabPane2: [
        {image: require("@/assets/img/examples/olu-eletu.jpg")},
        {image: require("@/assets/img/examples/clem-onojeghuo.jpg")},
        {image: require("@/assets/img/examples/cynthia-del-rio.jpg")},
        {image: require("@/assets/img/examples/mariya-georgieva.jpg")},
        {image: require("@/assets/img/examples/clem-onojegaw.jpg")}
      ],
      tabPane3: [
        {image: require("@/assets/img/examples/mariya-georgieva.jpg")},
        {image: require("@/assets/img/examples/studio-3.jpg")},
        {image: require("@/assets/img/examples/clem-onojeghuo.jpg")},
        {image: require("@/assets/img/examples/olu-eletu.jpg")},
        {image: require("@/assets/img/examples/studio-1.jpg")}
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.statsinfo {
  margin-left: auto;
}

.section {
  padding: 0;
}

.profile-tabs::v-deep {
  .md-card-tabs .md-list {
    justify-content: center;
  }

  [class*="tab-pane-"] {
    margin-top: 3.213rem;
    padding-bottom: 50px;

    img:not(.img) {
      margin-bottom: 2.142rem;
    }
  }
}
</style>
